import { QuestionPreviewNext } from "@vericus/cadmus-common";

import { useAnswerBlock } from "@/graphql/hooks";

import * as styles from "./answer-form.css";

interface Props {
  answerBlockId: string;
}

/**
 * Readonly preview of the Question prompt for an asnwers.
 */
export function PromptPreview(props: Props) {
  const { data, complete } = useAnswerBlock(props.answerBlockId);
  if (!data || !complete || !data.question) return null;

  return (
    <QuestionPreviewNext
      className={styles.parentQuestionPrompt}
      mode="question"
      questionId={data.question.id}
      promptDoc={data.question.body?.promptDoc ?? null}
      data={null}
      questionTitle={`Question ${data.orderLabel}`}
      isSubQuestion
    />
  );
}
